import markdownIt from "markdown-it";
// @ts-ignore — no types
import mdIns from "markdown-it-ins";
// @ts-ignore — no types
import mdSub from "markdown-it-sub";
// @ts-ignore — no types
import mdSup from "markdown-it-sup";
import type Core from "markdown-it/lib/parser_core";
import { useMemo } from "react";
import rules from "./rules";

export const disableTrailingSpaceNewline: Core.RuleCore = (state) => {
	for (const token of state.tokens) {
		if (token.type !== "inline" || !token.children) {
			continue;
		}

		for (const child of token.children) {
			if (child.type === "hardbreak") {
				child.type = "softbreak";
			}
		}
	}
};

export const createMarkdownItParser = (variant: keyof typeof rules) => {
	const { config, disabled } = rules[variant];
	const md = markdownIt(config)
		.use(mdSup)
		.use(mdSub)
		.use(mdIns)
		.disable(disabled);

	md.core.ruler.after(
		"inline",
		"disable-trailing-space-newline",
		disableTrailingSpaceNewline,
	);

	return md;
};

/**
 * Returns a markdown-it parser configured for the given variant.
 */
export const useMarkdownIt = (variant: keyof typeof rules) =>
	useMemo(() => createMarkdownItParser(variant), [variant]);
